"use client"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { cn } from "../../lib/utils"
import { Button } from "./button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select"

export function NewPagination({
  currentPage = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange = () => {},
  onItemsPerPageChange = () => {},
  className,
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const startItem = (currentPage - 1) * itemsPerPage + 1
  const endItem = Math.min(currentPage * itemsPerPage, totalItems)

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  // Don't render pagination if total items is 10 or less
  if (totalItems <= 10) {
    return null
  }

  return (
    <div className={cn("flex items-center justify-end px-4 py-4", className)}
    style={{ fontFamily: '"Poppins", sans-serif' }}>
      <div className="flex items-center">
        <div className="flex items-center space-x-2">
          <p className="text-sm text-gray-700">Rows per page:</p>
          <Select
            value={itemsPerPage !== undefined ? String(itemsPerPage) : ""}
            onValueChange={(value) => {
              if (onItemsPerPageChange) {
                onItemsPerPageChange(Number(value))
              }
            }}
          >
            <SelectTrigger className="h-8 w-[70px] border-none shadow-none bg-transparent">
              <SelectValue placeholder={itemsPerPage?.toString() ?? "—"} />
            </SelectTrigger>
            <SelectContent side="top" className="bg-white border border-gray-200 shadow-lg">
              {[10, 20, 30, 40, 50].map((pageSize) => (
                <SelectItem key={pageSize} value={pageSize.toString()} className="hover:bg-gray-50 focus:bg-gray-50">
                  {pageSize}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center justify-center text-sm text-gray-700">
          {startItem}-{endItem} of {totalItems}
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            className="h-8 w-8 p-0 border-none shadow-none bg-transparent hover:bg-gray-100"
            onClick={handlePrevious}
            disabled={currentPage <= 1}
          >
            <span className="sr-only">Go to previous page</span>
            <ChevronLeft className="h-4 w-4 text-gray-600" />
          </Button>
          <Button
            variant="outline"
            className="h-8 w-8 p-0 border-none shadow-none bg-transparent hover:bg-gray-100"
            onClick={handleNext}
            disabled={currentPage >= totalPages}
          >
            <span className="sr-only">Go to next page</span>
            <ChevronRight className="h-4 w-4 text-gray-600" />
          </Button>
        </div>
      </div>
    </div>
  )
}
